import { FormInstance, List } from "antd";
import { OpForm } from "components/customAntd/DLS/OpForm/OpForm";
import { InvitationDocument } from "types/visitorInvitationTypes";
import { useTranslation } from "react-i18next";

interface OptionsFormProps {
    form: FormInstance;
    invitationDocuments: InvitationDocument[];
    isPreRegistrationAllowed: number;
    setIsPreRegistrationAllowed: (checked: number) => void;
}

const OptionsForm: React.FC<OptionsFormProps> = ({ form, invitationDocuments, isPreRegistrationAllowed, setIsPreRegistrationAllowed }) => {
    const { t } = useTranslation();

    const handleAllowInvitationsChange = (checked: boolean) => {
        if (!checked) {
            form.setFieldsValue({ sendEmail: 0, allowPreRegistration: 0 });
            setIsPreRegistrationAllowed(0);
        }
    };

    const handleSendEmailChange = (checked: boolean) => {
        if (checked) {
            form.setFieldsValue({ allowInvitations: 1 });
        } else {
            form.setFieldsValue({ allowPreRegistration: 0 });
            setIsPreRegistrationAllowed(0);
        }
    };

    const handleAllowPreRegistrationChange = (checked: boolean) => {
        if (checked) {
            form.setFieldsValue({ allowInvitations: 1, sendEmail: 1 });
        }
        setIsPreRegistrationAllowed(checked ? 1 : 0);
    };

    return (
        <>
            <List
                header={t('invitations.form.optionsTitle')}
                dataSource={[
                    { label: t('invitations.form.allowInvitations'), name: 'allowInvitations' },
                    { label: t('invitations.form.sendEmail'), name: 'sendEmail' },
                    { label: t('invitations.form.allowPreRegistration'), name: 'allowPreRegistration' },
                    { label: t('invitations.form.invitationDocuments'), name: 'invitationDocuments' }
                ]}
                bordered
                style={{ marginBottom: '16px' }}
                renderItem={item => (
                    <List.Item style={{ width: '100%' }}>
                        {item.name === 'invitationDocuments' ? (
                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                <OpForm.Select
                                    name={item.name}
                                    label={item.label}
                                    mode="multiple"
                                    placeholder={t('invitations.form.invitationDocumentsPlaceholder')}
                                    options={invitationDocuments.map(document => ({
                                        label: document.name,
                                        value: document.id
                                    }))}
                                    disabled={!isPreRegistrationAllowed}
                                />
                            </div>
                        ) : (
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <OpForm.Switch
                                    name={item.name}
                                    onChange={
                                        item.name === 'allowInvitations'
                                            ? handleAllowInvitationsChange
                                            : item.name === 'sendEmail'
                                                ? handleSendEmailChange
                                                : item.name === 'allowPreRegistration'
                                                    ? handleAllowPreRegistrationChange
                                                    : undefined
                                    }
                                />
                                <span style={{ marginLeft: 8 }}>{item.label}</span>
                            </div>
                        )}
                    </List.Item>
                )}
            />
        </>
    );
};

export default OptionsForm;
